/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.headerModule', ['foundationModule', 'ngAnimate', 'lodash', 'bulbApp.activityModule',
  'bulbApp.alertsModule', 'bulbApp.busyModule', 'bulbApp.configModule', 'bulbApp.createModule',
  'bulbApp.pageModule', 'bulbApp.translateModule', 'bulbApp.unitModule']);
